var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame111(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 46,
    width: 45,
    height: 45,
    rx: 22.25,
    transform: "rotate(-180 46 46)",
    stroke: "#FFFAE6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8092 32.0914V20.4982H15.1259V32.0914H18.8092ZM16.9681 18.9144C18.2525 18.9144 19.052 18.0242 19.052 16.9117C19.0281 15.7741 18.2525 14.9086 16.9924 14.9086C15.7325 14.9086 14.9086 15.7741 14.9086 16.9117C14.9086 18.0242 15.7079 18.9144 16.944 18.9144H16.9679H16.9681ZM20.8479 32.0914H24.5313V25.6172C24.5313 25.2707 24.5552 24.9246 24.6524 24.6769C24.9187 23.9846 25.5248 23.2676 26.5423 23.2676C27.8751 23.2676 28.4083 24.3307 28.4083 25.8892V32.0913H32.0914V25.4439C32.0914 21.8829 30.2742 20.226 27.8508 20.226C25.8638 20.226 24.9914 21.388 24.5067 22.1793H24.5313V20.498H20.848C20.8964 21.5858 20.848 32.0912 20.848 32.0912L20.8479 32.0914Z",
    fill: "#FFFAE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame111);
export default __webpack_public_path__ + "static/media/frame-11-1.14c2c754840bf056a857066b63cca3f4.svg";
export { ForwardRef as ReactComponent };